import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CommonServices } from 'src/app/Services/common.service';

@Component({
  selector: 'g10-route-cutoff-form',
  templateUrl: './route-cutoff-form.component.html',
  styleUrls: ['./route-cutoff-form.component.css']
})
export class RouteCutoffFormComponent implements OnInit {

  @Input() matFormSize = '13px';
  @Input() popup = true;
  @Input() modalTitle = 'Route Cutoff';
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  public routeOptions:any = [];
  public selectedRoute: any = [];
  @ViewChild('routeSearch') routeSearchTextBox: ElementRef;
  routeSearchChangeObserver: any;
  public routeSearchVal: any = '';
  public showRouteField:boolean = false;
  
  public formObject: any = {
    action: '',
    duration: '',
    comments: '',
    routeID: '',
  };
  public errorObject = JSON.parse(JSON.stringify(this.formObject));
  //Button
  public submitBtnPressed: boolean = false;

  constructor(
    private comService: CommonServices,
  ) { }

  ngOnInit(): void {
    this.loadRouteData();
  }

  routeOptionFn(res:any){
    let returnData = [];
    if(res.data && res.data.length>0){
      returnData = res.data.map((item)=>{
        let option = { name: item.title, value:item.routeID };/*  ,badge: '1', badgeClass:'bg-primary text-white rounded-pill px-2 badgePosRel' }; */
        return option;
      })
    }
    return returnData;
  }

  async loadRouteData(title?){
    this.showRouteField = false;
    let obj = {};
    if(title) obj['title'] = title;
    let data:any = await this.comService.getAPILoopData('transportMangerRouteList',obj).catch((e)=>{ console.log('api loop error',e);})
    if(data.length>0){
      this.routeOptions = data.map((item)=>{
        let option = { name: item.title, value:item.routeID };
        return option;
      })
    }
    this.showRouteField = true;
  }

  /* Dropdown */

  dropdownChangeEvent(value){
    if(Array.isArray(value)) value = value.filter((val)=> val!='All' );
    this.formObject.routeID = value;
    console.log(value);
    // this.validation();
    // this.dropdownSelectionResult(value, 'selectedRoute', 'routeOptions', 'showRouteField', 'routeSearchTextBox');
  }

  /* Form Validation */
  validation() {
    let objectKeys = Object.keys(this.formObject).filter(key => key != 'safeDrop');
    // if (this.formObject.comment == undefined) { objectKeys = objectKeys.filter(key => key != 'comment'); }
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
        if(key=='routeID') this.errorObject[key] = "Route is required";
        else this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      }
      else if(key=='duration'){
        let date = new Date(new Date().setHours(0,0,0,0)).getTime();
        let [hour,minute] = this.formObject[key].split(':');
        let formdate = new Date(new Date().setHours(+hour,+minute,0,0)).getTime();
        if(date >= formdate){
          this.errorObject[key] = 'Duration is invalid.';
        }
      }
    }
    return isValid;
  }

  closePopup() {
    this.closeEvent.emit(true);
  }

  onSubmit() {
    this.submitBtnPressed = true;
    let isValid = this.validation();
    if (isValid) {
      let returnObj = {
        action: this.formObject.action,
        routeID: this.formObject.routeID ,
        duration: this.formObject.duration,
      }
      if(this.formObject.comments!='') returnObj['comment'] = String(this.formObject.comments).trim();
      this.result.emit(returnObj);
      this.closeEvent.emit(true);
    }
  }

}
